import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLocalizedPath } from '../hooks/useLocalizedPath';
import { useI18nLocaleSync } from '../hooks/useI18nLocaleSync';
import { pathWithLocale } from '../lib/locale';
import { useAppLocale } from '../hooks/useAppLocale';

export function Story() {
  const { t } = useTranslation();
  const locale = useAppLocale();
  const lp = useLocalizedPath();

  useI18nLocaleSync();

  usePageMeta({
    title: t('story.metaTitle'),
    description: t('story.metaDesc'),
    path: pathWithLocale('/story', locale),
  });

  return (
    <main className="content">
      <nav className="breadcrumb" aria-label={t('layout.breadcrumbLabel')}>
        <Link to={lp('/')}>{t('breadcrumb.home')}</Link>
        <span className="sep">/</span>
        <span className="current">{t('story.breadcrumb')}</span>
      </nav>

      <article className="about-section">
        <h1>{t('story.title')}</h1>
        <p className="story-qa-intro">
          <Trans
            i18nKey="story.intro"
            components={{
              about: <Link to={lp('/about')} />,
              faq: <Link to={lp('/faq')} />,
            }}
          />
        </p>

        <p dangerouslySetInnerHTML={{ __html: t('story.p1') }} />
        <p dangerouslySetInnerHTML={{ __html: t('story.p2') }} />
        <p dangerouslySetInnerHTML={{ __html: t('story.p3') }} />
        <p dangerouslySetInnerHTML={{ __html: t('story.p4') }} />
        <p dangerouslySetInnerHTML={{ __html: t('story.p5') }} />
        <p dangerouslySetInnerHTML={{ __html: t('story.p6') }} />

        <h2 style={{ fontSize: '1.15em', marginTop: 20, marginBottom: 8, color: 'var(--text-primary)' }}>
          {t('story.hStrategy')}
        </h2>
        <ul style={{ margin: '8px 0 0 20px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
          <li>
            <Trans
              i18nKey="story.liHunt"
              components={{
                hunt: <strong />,
                gen: <strong />,
                auto: <Link to={`${lp('/')}#auto-search`} />,
              }}
            />
          </li>
          <li dangerouslySetInnerHTML={{ __html: t('story.liSync') }} />
          <li dangerouslySetInnerHTML={{ __html: t('story.liPlay') }} />
        </ul>

        <h2 style={{ fontSize: '1.15em', marginTop: 24, marginBottom: 8, color: 'var(--text-primary)' }}>
          {t('story.hScience')}
        </h2>
        <p>{t('story.pScience')}</p>

        <h2 style={{ fontSize: '1.15em', marginTop: 24, marginBottom: 8, color: 'var(--text-primary)' }}>
          {t('story.hWhat')}
        </h2>
        <p dangerouslySetInnerHTML={{ __html: t('story.pWhat1') }} />
        <p dangerouslySetInnerHTML={{ __html: t('story.pWhat2') }} />

        <p style={{ marginTop: 20 }}>
          <Trans
            i18nKey="story.footerLinks"
            components={{
              about: <Link to={lp('/about')} />,
              faq: <Link to={lp('/faq')} />,
            }}
          />
        </p>
      </article>
    </main>
  );
}
